// lib/promanity-domains.ts

function normalizeDomain(value: string | null | undefined) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    .replace(/^www\./, '')
    .replace(/:\d+$/, '')
}

export function getPromanityDomains() {
  return String(
    process.env.NEXT_PUBLIC_PROMANITY_DOMAINS || ''
  )
    .split(',')
    .map(normalizeDomain)
    .filter(Boolean)
}

export function isPromanityDomain(
  domain: string | null | undefined
) {
  const normalizedDomain = normalizeDomain(domain)

  return getPromanityDomains().includes(normalizedDomain)
}